export enum SocialIcon {
  ICON_DZEN = 'ICON_DZEN',
  ICON_TELEGRAM = 'ICON_TELEGRAM',
  ICON_YOUTUBE = 'ICON_YOUTUBE',
  ICON_UNSPECIFIED = 'ICON_UNSPECIFIED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export const footerContent = {
  copyright: 'Pogovorim. Все права защищены',
  legalLinks: [
    {
      text: 'Политика конфиденциальности',
      url: 'https://pogovorim.online/documents/privacy-policy.pdf',
      target: '_self',
    },
    {
      text: 'Пользовательское соглашение',
      url: 'https://pogovorim.online/documents/public-offer-user.pdf',
      target: '_self',
    },
  ],
  linksForClients: [
    {
      text: 'Консультации',
      url: 'https://pogovorim.online/client/consultations/',
      target: '_self',
    },
    {
      text: 'Подарочные сертификаты',
      url: 'https://poisk.pogovorim.online/certificate_new',
      target: '_blank',
    },
    {
      text: 'Чекап',
      url: 'https://check-up.pogovorim.online/balance',
      target: '_blank',
    },
    {
      text: 'Блог',
      url: 'https://b2b.pogovorim.online/media',
      target: '_blank',
    },
  ],
  linksForTherapists: [
    {
      text: 'Присоединиться к платформе',
      url: 'https://pogovorim.online/therapists/',
      target: '_self',
    },
    {
      text: 'Найти супервизора',
      url: 'https://pogovorim.online/supervisors/',
      target: '_self',
    },
    {
      text: 'Вакансии',
      url: 'https://hh.ru/employer/10104616',
      target: '_blank',
    },
  ],
  linksForBusiness: [
    {
      text: 'Корпоративные решения',
      url: 'https://b2b.pogovorim.online/',
      target: '_blank',
    },
    {
      text: 'Диагностика',
      url: 'https://b2b.pogovorim.online/burnout',
      target: '_blank',
    },
    {
      text: 'Индивидуальные сессии',
      url: 'https://b2b.pogovorim.online/individual',
      target: '_blank',
    },
  ],
  contacts: [
    {
      text: 'ceo@pogovorim.online',
      url: 'mailto:ceo@pogovorim.online',
      subText: 'Для идей, сотрудничества и партнерства',
    },
    {
      text: 'pr@pogovorim.online',
      url: 'mailto:pr@pogovorim.online',
      subText: 'Для рекламы',
    },
  ],
  socialLinks: [
    {
      url: 'https://dzen.ru/pogovorimonline',
      icon: SocialIcon.ICON_DZEN,
      target: '_blank',
    },
    {
      url: 'https://t.me/PogovorimOnline',
      icon: SocialIcon.ICON_TELEGRAM,
      target: '_blank',
    },
  ],
  emailToSupport: {
    text: 'prosto@pogovorim.online',
    url: 'mailto:prosto@pogovorim.online',
    subText: 'Клиентский сервис',
  },
  linkToSupport: {
    text: 'Напишите нам',
    url: 'https://wa.me/+79198707755',
    subText: 'Работаем с 9:00 до 21:00 (МСК)',
  },
  linkToLogin: {
    text: 'Войти в личный кабинет',
    url: 'https://pogovorim.online/login/',
    target: '_self',
  },
};
